// @ts-ignore
if (window.__MICRO_APP_ENVIRONMENT__) {
  // @ts-ignore
  __webpack_public_path__ = '/' + window.__MICRO_APP_NAME__ + '/';
} else {
  // @ts-ignore
  __webpack_public_path__ = '/';
}
